var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-flowchart-editor-container"},[_c('flowchart-editor',{key:_vm.reRender,attrs:{"read-only":_vm.readOnly,"chart-data":_vm.flowChartData,"chart-data-node-items":_vm.flowChartNodeItems},on:{"save-data":_vm.save}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }